const popups_ready = (callback) => {
   if (document.readyState != "loading") callback();
   else document.addEventListener("DOMContentLoaded", callback);
};

popups_ready(() => {
   const modalButtonsClose = document.querySelectorAll('.js-button-close');
   const buttonsOpenModal = document.querySelectorAll('.wcl-open-modal');
   const modalWrappers = document.querySelectorAll('.data-modal-wrapper');
   const bodyWrapper = document.getElementsByTagName('body')[0];

   // Handler for clicking on the button to close a modal window
   modalButtonsClose.forEach(function (element) {
      element.addEventListener('click', function () {
         const modal = this.closest('.wcl-modal');
         if (modal) {
            modal.classList.remove('active');
            bodyWrapper.classList.remove('overflow-hidden');
         }
      });
   });

   // Handler for clicking the button to open a modal window
   buttonsOpenModal.forEach(function (element) {
      element.addEventListener('click', function (event) {
         event.preventDefault();
         const modalName = this.getAttribute('data-modal');
         const modal = document.getElementById(modalName);

         if (modal) {
            modal.classList.add('active');
            bodyWrapper.classList.add('overflow-hidden');
         }
      });
   });

   //Closing a modal window when clicking outside the main content block
   modalWrappers.forEach(function (wrapper) {
      wrapper.addEventListener('click', function (event) {
         if (event.target === this) {
            const modal = this.closest('.wcl-modal');
            if (modal) {
               modal.classList.remove('active');
               bodyWrapper.classList.remove('overflow-hidden');
            }
         }
      });
   });
});
